import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-card-link',
    templateUrl: './card-link.component.html',
    standalone: false
})
export class CardLinkComponent {
    @Input() labelClass = 'col-2';
    @Input() label: string;
    @Input() class = 'col-8';
    @Input() value: string;
    @Input() prefix: string;
    @Input() target: string[];
    @Input() isFromControl: boolean;
    

    constructor(
        private router: Router
    ) {}

    public navigateToTarget(e): void {
      e.preventDefault();
      this.router.navigate([...this.target]);
    }

}
